@if (isLoading) {
  <div class="spinner-overlay" [ngClass]="spinnerOverlayAddedClass">
    <div class="spin" [ngClass]="classesString">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{ 'loading-spinner.loading' | translate }}</span>
      </div>
    </div>
  </div>
}
